/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".product-dialog .mat-dialog-container{overflow:visible!important}.product-dialog .mat-dialog-container .close-btn-outer{position:relative}.product-dialog .mat-dialog-container .close-btn-outer button{position:absolute;right:-44px;top:-44px}.product-dialog .mat-dialog-container .swiper-slide{text-align:center}.product-dialog .mat-dialog-container .swiper-slide img{max-width:100%}.downloadAppFrame{margin-top:25px}.downloadAppH3{text-align:center}"];
export { styles as styles };
